import React, { useState } from 'react';
import { useAnalytics } from '../contexts/AnalyticsContext';
import Sidebar from './layout/Sidebar';
import Navbar from './layout/Navbar';
import MetricsCards from './MetricsCards';
import VisitorsChart from './VisitorsChart';
import TopPages from './TopPages';
import RealTimeUsers from './RealTimeUsers';
import TrafficSources from './TrafficSources';
import DeviceBreakdown from './DeviceBreakdown';
import UserList from './UserList';
import FunnelAnalysis from './FunnelAnalysis';
import ReportScheduler from './ReportScheduler';
import CustomEventsDashboard from './CustomEventsDashboard';
import IdentityResolution from './IdentityResolution';
import PlatformHealth from './PlatformHealth';
import ChangeLog from './ChangeLog';
import GroupConfig from './GroupConfig';
import TrackingSetup from './TrackingSetup';

const Dashboard = () => {
  const { clearData } = useAnalytics();
  const [activeTab, setActiveTab] = useState('overview');
  const [timeRange, setTimeRange] = useState('7d');

  return (
    <div className="min-h-screen bg-slate-50 flex">
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      
      <div className="flex-1 ml-64 flex flex-col min-w-0">
        <Navbar clearData={clearData} />
        
        <main className="p-8 max-w-7xl mx-auto w-full">
          <div className="mb-8 flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div>
              <h2 className="text-2xl font-bold text-slate-900">
                {activeTab.charAt(0).toUpperCase() + activeTab.slice(1).replace('_', ' ')}
              </h2>
              <nav className="flex text-xs text-slate-500 mt-1">
                <span>Intuitus</span>
                <span className="mx-2">/</span>
                <span className="font-medium text-slate-900 capitalize">{activeTab}</span>
              </nav>
            </div>

            {activeTab === 'overview' && (
              <div className="flex bg-white p-1 rounded-lg border border-slate-200 shadow-sm">
                {['24h', '7d', '30d', '90d'].map((range) => (
                  <button
                    key={range}
                    onClick={() => setTimeRange(range)}
                    className={`px-3 py-1 rounded-md text-xs font-semibold transition-all ${
                      timeRange === range 
                        ? 'bg-slate-900 text-white shadow-sm' 
                        : 'text-slate-500 hover:text-slate-900'
                    }`}
                  >
                    {range}
                  </button>
                ))}
              </div>
            )}
          </div>

          <div className="space-y-8 animate-in fade-in slide-in-from-bottom-2 duration-500">
            {activeTab === 'overview' && (
              <>
                <RealTimeUsers />
                <MetricsCards timeRange={timeRange} />
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                  <div className="lg:col-span-2">
                    <VisitorsChart timeRange={timeRange} />
                  </div>
                  <div className="space-y-8">
                    <TrafficSources />
                    <DeviceBreakdown />
                  </div>
                </div>
                <TopPages />
              </>
            )}

            {activeTab === 'events' && <CustomEventsDashboard />}
            {activeTab === 'funnels' && <FunnelAnalysis />}
            {activeTab === 'users' && <UserList />}
            {activeTab === 'resolution' && <IdentityResolution />}
            {activeTab === 'groups' && <GroupConfig />}
            {activeTab === 'health' && <PlatformHealth />}
            {activeTab === 'audit' && <ChangeLog />}
            {activeTab === 'reports' && <ReportScheduler />}
            {activeTab === 'settings' && <TrackingSetup />}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Dashboard;